import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.modelList;

const modelListData = createSelector([selector], (state) => state);

export default {
  modelListData
};
